import { VipBrandsValue } from '../../../server';
import { FlagDTO } from './FlagDTO';

export type FlagValue = {
    id: string;
    label: string;
    endDate?: string;
};

export const mapFlag = (
    { id, label, endDate }: FlagDTO,
    brandId: string,
    vipBrands: VipBrandsValue,
): FlagValue | null => {
    if (!id || !label) return null;

    const enableEndOfDate = vipBrands[brandId]?.enableEndOfDate ?? true;

    return {
        id,
        label,
        ...(endDate && enableEndOfDate ? { endDate } : {}),
    };
};

export const mapFlags = (
    flags: FlagDTO[] | undefined,
    brandId: string,
    vipBrands: VipBrandsValue,
): FlagValue[] | undefined =>
    flags?.map((flag) => mapFlag(flag, brandId, vipBrands)).filter((flag): flag is FlagValue => flag !== null);
